<template>
  <v-container>
    <v-card elevation="6" class="" color="#F5F5F5">
      <v-card-title style="color: #B08836"  class="font-weight-bold">
        <h2 class="heading font-weight-bold"> Historial de Promociones</h2>
        <v-spacer></v-spacer>
        <v-btn class="mr-1" color="#0A4A79" dark to="/panel" small>
          <v-icon small class="mr-5">mdi-arrow-left</v-icon>
          Ir a Panel
        </v-btn>
        <v-btn small style="background-color:#0A4A79" class="mr-1" to="/estadistica" dark>
          <v-icon small dark class="mr-3">mdi-file</v-icon> Estadística Promociones
          <div class="flex-grow-1"></div>
        </v-btn>
      </v-card-title>
      <!-- <v-card-text>
        <h3> <b>{{roleUser.toUpperCase()}}:</b> {{currentUser.nombre + ' ' +currentUser.primer_apellido+ ' ' +currentUser.segundo_apellido}}</h3>
      </v-card-text> -->
      <div class="mx-5">
        <v-card><br>
          <v-container>
          <div class="">
            <v-row>
              <v-col cols="12" sm="4">
                <v-select
                  :items="listSalas"
                  v-model="sala_id"
                  label="Sala"
                  item-value="id"
                  item-text="nombre"
                  clearable
                  dense
                  outlined
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  :items="listStatus"
                  v-model="status"
                  label="Estatus"
                  prepend-inner-icon="mdi-file-alert-outline"
                  item-value="id"
                  item-text="nombre"
                  clearable
                  outlined
                  dense
                  >
                </v-select>
              </v-col>
            <v-col class="" cols="6" md="3">
              <v-menu
                ref="dialogFecInicio"
                v-model="dialogFecInicio"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fecha_inicio"
                    label="Fecha Inicial"
                    prepend-inner-icon="mdi-calendar-outline"
                    readonly
                    v-on="on"
                    dense
                    clearable
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha_inicio"
                  @input="dialogFecInicio = false"
                  locale="es-mx"
                  min="2010-01-01"
                  :max="new Date().toISOString().substr(0, 10)"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="" cols="6" md="3">
              <v-menu
                ref="dialogFecInicio"
                v-model="dialogFecFin"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fecha_fin"
                    label="Fecha Final"
                    prepend-inner-icon="mdi-calendar-outline"
                    readonly
                    v-on="on"
                    dense
                    outlined
                    clearable
                    :disabled="disabledFechaFin"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha_fin"
                  @input="dialogFecFin = false"
                  locale="es-mx"
                  :min="fecha_inicio"
                  :max="new Date().toISOString().substr(0, 10)"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            </v-row>
            <v-row class="mt-n9">
            <v-spacer></v-spacer>
              <v-col cols="12" md="2">
                <v-btn class="mb-3 white--text" small block color="#0A4A79" @click="getPromociones()" >
                  <v-icon class="mr-4">mdi-magnify</v-icon>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <div class="flex-grow-1">
                  <h4>Total de Promociones: {{ total_promociones }}</h4>
                </div>
              </v-col>
              <v-col cols="12" md="3">
                <v-btn color="red" class="white--text" small :loading="loadingPdf" @click="getAcuse()">
                  <v-icon small class="mr-1">mdi-file-pdf</v-icon>
                  Generar PDF
                </v-btn>
              </v-col>
            </v-row>

          </div>
          </v-container>

          <template>
          <v-card-title style="color:#0A4A79">
            <h5> Promociones </h5>
            <div class="flex-grow-1"></div>
          </v-card-title>

          <v-data-table
            dense
            :headers="headers"
            :items="listData"
            item-key="user"
            class="elevation-1"
            light
            actions
            :loading="loadingTable"
            :page.sync="page"
            :items-per-page="per_page_table"
            hide-default-footer
            @page-count="pageCount = $event"
          >
          <template v-slot:item.area="{ item }">
            <td><span>Sala {{item.sala_id}}</span></td>
          </template>
          <template v-slot:item.numero_completo="{ item }">
          {{ item.numero_completo}}
          </template>
          <!-- <template v-slot:item.abogado="{ item }">
            <span v-if="item.abogado">Abogado: {{item.abogado}}</span><br>
          </template> -->

          <template v-slot:item.status="{ item }">
            <td v-if="item.status == 2" >Registrada</td>
            <td v-if="item.status == 3" >Contestada</td>
          </template>

          <template v-slot:item.registro="{ item }" >
            <td>
              <span>{{item.created_at | formatDate}} {{ }}</span>
            </td>
          </template>
          <template v-slot:item.contestacion="{ item }" >
            <td>
              <span v-if="item.fecha_contestacion">{{item.fecha_contestacion | formatDate}}</span><br v-if="item.fecha_contestacion">
            </td>
          </template>
            <template v-slot:item.action="{ item }">
              <v-btn x-small color="green" dark @click="showPromocion(item)">
                <v-icon small dark class="mr-3">mdi-file</v-icon>
                  Ver Promoción
              </v-btn>
            </template>
          </v-data-table>
        </template>
          <div class="text-center pt-2">
            <v-pagination
              v-if="pagination.total > 1"
              v-model="pagination.current"
              :length="pagination.total"
              :total-visible="7"
              @input="onPageChange"
              color="blue"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
            ></v-pagination>
          </div>

        </v-card>
      </div>
      <br>
    </v-card>
    <v-dialog
      v-model="progress"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="#0A4A79"
        dark
      >
        <v-card-text>
          Cargando Archivo
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-container>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      valid: true,
      dialog: false,
      loadingTable: false,
      loadingPdf: false,
      progress: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      per_page_table: 1,
      listData: [],
      status:'',
      dialogFecInicio: false,
      dialogFecFin: false,
      disabledFechaFin: true,
      fecha_inicio: '',
      fecha_fin:'',
      // magistrado: '',
      // total_firmados: '',
      total_promociones:'',
      sala_id: '',
      pagination: {
        current: 1,
        total: 0
      },
      headers: [
        { text: 'TOCA', value: 'numero_completo' },
        { text: 'SALA', value: 'area' },
        { text: 'ESTATUS', value: 'status', sortable: false },
        { text: 'REGISTRO', value: 'registro' },
        { text: 'CONTESTACIÓN', value: 'contestacion' },
        { text: 'ACCIONES', value: 'action', sortable: false },
      ],
      listStatus: [
        { id: '2', nombre: 'Registrada' },
        { id: '3', nombre: 'Contestada' }
      ],
      // activo: true,
      // notBlankRules: [v => !!v || 'Este campo es requerido'],
    }
  },
  created() {
    this.$store.commit("SET_LAYOUT", "dashboard-layout");
  },
  computed: {
    ...mapGetters(["roleUser", 'listMagistrados', 'listSalas', 'currentUser']),
  },
  watch: {
    sala_id: function (val) {
      this.pagination.current = 1;
    },
    status: function (val) {
      this.pagination.current = 1;
    },
    fecha_inicio: function (val) {
      this.pagination.current = 1;
      this.disabledFechaFin = false
      if(!val){
      this.disabledFechaFin = true
        this.fecha_fin = ''
      }
    },
    fecha_fin: function (val) {
      this.pagination.current = 1;
    },
  },
  mounted() {
    this.getSalas();
    // this.getMagistrados();
    this.getPromociones();
  },
  // watch: {
  //   dialog (val) {
  //     val || this.close()
  //   }
  // },
  methods: {
    onPageChange() {
      this.getPromociones();
    },
    getPromociones() {
      this.loadingTable = true
      this.$store.dispatch("GET_PROMOCIONES", {
          url:"/promociones?page="+this.pagination.current,
          params: {
            status:this.status,
            sala_id:this.sala_id,
            fecha_ini:this.fecha_inicio,
            fecha_fin:this.fecha_fin
          }
        })
        .then((response) => {
          // console.log(response.data);
          this.loadingTable = false
          this.pagination.current = response.data.data.promociones.current_page;
          this.pagination.total = response.data.data.promociones.last_page;
          this.per_page_table = response.data.data.promociones.per_page;
          this.listData = response.data.data.promociones.data;
          this.total_promociones = response.data.data.promociones.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    showPromocion(item){
      this.$store.dispatch("SHOW_PROMOCION", {
        url:"/promocion/"+ item.id,
      } )
      .then((response) => {
      this.$router.push('/escritos/show' )
      })
      .catch(err => {
        console.log(err);
      });
    },
    getSalas() {
      this.salaSelected = ''
      this.$store.dispatch("GET_SALAS",  { url: "/salas",
      }).then(response => {
        // console.log(response.data);
        this.salasList = response.data.data.salas
      })
      .catch(err => {
        console.log(err);
      });
    },
    // getMagistrados(){
    //   this.$store.dispatch("GET_MAGISTRADOS",  { url: "/magistrados" })
    //     .then(response => {
    //       // console.log(response.data);
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
    // },
    getAcuse(){
      this.loadingPdf = true;
      this.progress = true;
      this.$store.dispatch("GET_ACUSE", { url: "/promociones/reportePdf",
        data: {
          sala_id: this.sala_id,
          status: this.status,
          fecha_ini: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
        }
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('target' ,'_blank');
        document.body.appendChild(link);
        link.click();
        this.progress = false;
        this.loadingPdf = false;
      })
      .catch(err => {
        console.log(err);
        this.progress = false;
        this.loadingPdf = false;
      });
    },
  }
}
</script>
